"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var memoize = require("fast-memoize");
var queryString = require("query-string");
var CongridConfigurationModal_1 = require("components/modals/CongridConfigurationModal");
var configModalActions = require("@caddigital/sok-reducers/lib/actions/congrid/configModal");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var filesActions = require("@caddigital/sok-reducers/lib/actions/congrid/files");
var filestabActions = require("@caddigital/sok-reducers/lib/actions/files");
var projectsActions = require("@caddigital/sok-reducers/lib/actions/congrid/projects");
var avatars_1 = require("components/Avatar/avatars");
var Icon_1 = require("components/Icon");
var Types = require("types");
var fileList_1 = require("./fileList");
var search_1 = require("utils/search");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage,
        files: state.congrid.files,
        projects: state.congrid.projects,
        projectMetadata: state.files.metadata,
        congridModalStatus: state.congrid.configModal.isOpen
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    getProjects: function (id) { return dispatch(projectsActions.fetchRequest(id)); },
    getMetas: function (id) { return dispatch(filestabActions.fetchSchema(id)); },
    getFiles: function (id) { return dispatch(filesActions.fetchRequest(id)); },
    clear: function () { return (dispatch(filesActions.clear()), dispatch(projectsActions.clear())); },
    toggleModal: function () { return dispatch(configModalActions.toggleModal()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
function _getProjectId(processed, selected) {
    if (processed.length > 0) {
        var proj = processed.findIndex(function (x) { return x.id === selected; });
        if (proj !== -1) {
            return { index: proj, project: processed[proj] };
        }
        else {
            return { index: proj, project: processed[0] };
        }
    }
    return { index: 0, project: null };
}
var getProjectId = memoize(_getProjectId);
var getParams = function (search) {
    var params = queryString.parse(search);
    var keys = Object.keys(params).sort(function (a, b) { return a.localeCompare(b); });
    // Decode params
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        params[key] = decodeURIComponent(params[key]);
    }
    return params;
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('selected', 'setSelected', null), (0, recompose_1.withState)('processed', 'setProcessed', []), (0, recompose_1.withState)('queryParams', 'setQueryParams', {}), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.getProjects(this.props.currentProject.id);
        var params = getParams(this.props.location.search);
        this.props.setQueryParams(params);
        var id = parseInt(params.project, 10);
        if (!isNaN(id)) {
            this.props.setSelected(id);
        }
        if (this.props.projectMetadata.status === 'STANDBY' ||
            this.props.projectMetadata.status === 'FAILURE') {
            this.props.getMetas(this.props.currentProject.rootFolder);
        }
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.currentProject.id !== prevProps.currentProject.id ||
            (this.props.projects.status === 'STANDBY' &&
                prevProps.projects.status !== 'STANDBY')) {
            this.props.getProjects(this.props.currentProject.id);
        }
        if (this.props.projects.items !== prevProps.projects.items) {
            var projects = this.props.projects.items.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            this.props.setProcessed(projects);
        }
        if (this.props.processed.length > 0 &&
            (this.props.selected !== prevProps.selected ||
                this.props.processed !== prevProps.processed)) {
            if (this.props.selected === null ||
                this.props.processed.findIndex(function (x) { return x.id === _this.props.selected; }) === -1) {
                var select = this.props.processed[0].id;
                this.props.getFiles(select);
                this.props.setSelected(select);
                if (this.props.selected !== null) {
                    this.props.history.replace(this.props.location.pathname);
                }
            }
            else {
                this.props.getFiles(this.props.selected);
            }
        }
        if (this.props.location.search !== prevProps.location.search) {
            var params = getParams(this.props.location.search);
            this.props.setQueryParams(params);
            var id = parseInt(params.project, 10);
            if (!isNaN(id)) {
                this.props.setSelected(id);
            }
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var Wrapper = (0, recompose_1.pure)(function (props) {
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'congrid-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/projects/").concat(props.currentProject.id) }, props.currentProject.name),
                    React.createElement("span", null, (0, translation_1.getLocalization)('breadcrumb/congrid'))),
                React.createElement("div", { className: 'link-congrid-btn' },
                    React.createElement(sok_ui_1.Button, { size: 'medium', onClick: function () { return props.toggleModal(); }, color: 'green', icon: React.createElement(Icon_1.Icon, { className: 'fa-plus' }) }, (0, translation_1.getLocalization)('congrid/link-btn'))),
                props.children)),
        props.modalStatus && (React.createElement(CongridConfigurationModal_1.default, { projectId: props.currentProject.id }))));
});
function _getChildrens(list) {
    return list
        .map(function (x) { return React.createElement("div", { key: 'header-' + x.id }, x.name); })
        .concat(list.map(function (_, i) { return React.createElement("div", { key: 'child-' + i }); }));
}
var getChildrens = memoize(_getChildrens);
exports.default = enhance(function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    if (props.projects.status === 'FAILED') {
        return (React.createElement(Wrapper, { selectedLanguage: selectedLanguage, currentProject: props.currentProject, modalStatus: props.congridModalStatus, toggleModal: props.toggleModal },
            React.createElement("div", { className: 'center' },
                React.createElement(GenericErrorMessage_1.default, null,
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.getProjects(props.currentProject.id); } })))));
    }
    if (props.projects.status === 'FETCHING') {
        return (React.createElement(Wrapper, { selectedLanguage: selectedLanguage, currentProject: props.currentProject, modalStatus: props.congridModalStatus, toggleModal: props.toggleModal },
            React.createElement("div", { className: 'center' },
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    if (props.projects.items.length === 0) {
        return (React.createElement(Wrapper, { selectedLanguage: selectedLanguage, currentProject: props.currentProject, modalStatus: props.congridModalStatus, toggleModal: props.toggleModal },
            React.createElement("div", { className: 'no-congrid-projects' },
                React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
                React.createElement("b", null, (0, translation_1.getLocalization)("congrid/projects/emptyList/title")),
                React.createElement("span", null, (0, translation_1.getLocalization)("congrid/projects/emptyList/message")))));
    }
    var current = getProjectId(props.processed, props.selected);
    return (React.createElement(Wrapper, { selectedLanguage: selectedLanguage, currentProject: props.currentProject, modalStatus: props.congridModalStatus, toggleModal: props.toggleModal },
        React.createElement("div", { className: 'projects' },
            React.createElement(sok_ui_1.Tabs, { onClick: function (x) {
                    if (props.processed.length > x) {
                        var project = props.processed[x].id;
                        var params = { project: project.toString() };
                        props.history.push(props.location.pathname + (0, search_1.getQueryParams)(params));
                        props.setSelected(project);
                    }
                }, activeIndex: current.index }, getChildrens(props.processed)),
            React.createElement("div", { className: 'tools' },
                React.createElement(sok_ui_1.Button, { color: 'green', size: 'medium', url: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/congrid/").concat(current.project && current.project.id, "/link") }, (0, translation_1.getLocalization)('congrid/list/linkNewFile'))),
            React.createElement(fileList_1.ListContainer, { projectMetadata: props.projectMetadata.list, selectedProject: current.project, currentProject: props.currentProject, queryParams: props.queryParams, pathname: props.location.pathname, updateUrl: props.history.push }))));
});
